import { patch } from '../../../../infra/rest';

export const markChatDone = async ({
  chatId,
  isDone,
  markChatRead,
}: {
  chatId: string;
  isDone: boolean;
  markChatRead?: boolean;
}): Promise<boolean> => {
  if (!chatId) return false;

  return patch<boolean>(
    `/v1/conversation/${chatId}/status`,
    {
      body: JSON.stringify({
        isDone,
        markChatRead,
      }),
    },
    true
  );
};

export const markMultipleChatsDone = async ({
  chatIds,
  isDone,
}: {
  chatIds: string[];
  isDone: boolean;
}): Promise<boolean> => {
  if (!chatIds || chatIds.length === 0) return false;

  return patch<boolean>(
    `/v1/conversation/mark-multiple-done`,
    {
      body: JSON.stringify({
        chatIds,
        isDone,
      }),
    },
    true
  );
};
